let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2PUwR")).then(() => parcelRequire('AkBvw'));